import timesheetService from '@/services/timesheet';
import timesheet from '../../services/timesheet';
// import moment from "moment";

const getDefaultState = () => {
    return {
        dataSource: {},
        userTypes: [],
        isLoading: false,
    }
}

export const state = getDefaultState();

export const actions = {
    fetchTimesheet() {
        return new Promise((resolve, reject) => {
            timesheetService.fetchTimesheet().then((res) => {
                resolve(res.data);
                // commit('setPivotGrid', res.data);
            }).catch((err) => {
                reject(err)
            })
        })
    },
    resetTimesheetState({ commit }) {
        commit('resetTimesheet')
    },
    prepareTimesheet({ commit }, timesheetParams) {
        return new Promise((resolve, reject) => {
            timesheet.prepareTimeSheet(timesheetParams).then(res => {
                resolve(res.data);
                commit('setTimesheet', res.data);
            }).catch(err => {
                reject(err)
            })
        })
    },
    fetchSitesUserTypes({ commit }, site_ids) {
        commit("setLoading", true)
        return new Promise((resolve, reject) => {
            timesheet.sitesUserTypes(site_ids).then(res => {
                resolve(res.data)
                commit('setUserTypes', res.data)
                commit("setLoading", false)
            }).catch(err => {
                commit("setLoading", false)
                reject(err)
            })
        })
    }
}

export const mutations = {
    setTimesheet(state, payload) {
        state.dataSource = payload;
    },
    resetTimesheet(state) {
        Object.assign(state, getDefaultState())
    },
    setUserTypes(state, payload) {
        state.userTypes = payload
    },
    setLoading(state, status) {
        state.isLoading = status
    }
}

export const getters = {
    getTimesheet(state) {
        return state.dataSource;
    },
    getSitesUserTypes(state) {
        return state.userTypes
    },
    getLoaderStatus(state) {
        return state.isLoading
    }
}